import { openSidebar, closeSidebar } from "./actionCreators"

export const mapState = (state) => ({
  features: state.sessionReducer.features,
  isOpen: state.sidebarReducer.isOpen,
  availableModules: state.sessionReducer.availableModules,
  moduleData: state.sessionReducer.moduleData,
  sourceUrl: state.helpdeskReducer.sourceUrl,
})

export const mapDispatch = (dispatch) => ({
  openSidebar: () => dispatch(openSidebar()),
  closeSidebar: () => dispatch(closeSidebar()),
})
